// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"2ac91dca","263":"a42e608f"}[chunkId] + ".chunk.js";
};